import { yupResolver } from "@hookform/resolvers/yup";
import { AutoCompleteMenu } from "atoms";
import { FormContainer } from "components";
import {
    fileData,
    foldersStructureXmlFileFormData,
    identifiersData,
    inputData,
} from "data";
import { PropTypes } from "prop-types";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useFoldersStructureXmlFileSchema } from "schemas";
import { StyledTextField } from "styles";
import { renderFormControllerHandler } from "utils";

import FoldersStructureArtworkFileForm from "./artwork";
import FoldersStructureTrackFileForm from "./track";

const FoldersStructureXmlFileForm = ({
    action,
    modalData,
    onSubmitForm,
    setModalData,
    values,
}) => {
    const [fileType, setFileType] = useState(fileData.types.xml);

    const { t } = useTranslation();

    const selections = useSelector((state) => state.selectionsReducer);

    const schema = useFoldersStructureXmlFileSchema();

    const formMethods = useForm({
        defaultValues: values,
        mode: "onChange",
        resolver: yupResolver(schema),
    });

    const {
        control,
        formState: { errors },
        getValues,
    } = formMethods;

    const {
        fileName: fileNameInputName,
        fileType: fileTypeInputName,
    } = inputData.names;

    const changeAutoCompleteMenuValueHandler = (option, name, field) => {
        if (name === fileTypeInputName) {
            setFileType(option?.label);

            field.onChange(option?.value);
        } else field.onChange(option?.value);
    };

    const renderFormControllerChildrenHandler = (
        field,
        label,
        name,
        fieldType,
        __,
        selectionKey,
    ) => {
        if (fieldType === inputData.types.text) {
            return (
                <StyledTextField
                    {...field}
                    error={errors[name]}
                    helperText={errors[name] && errors[name]?.message}
                    id={`${name}_${identifiersData.ids.input}`}
                    label={t(`labels.${label}`)}
                    variant="outlined"
                    fullWidth
                />
            );
        }

        return (
            <AutoCompleteMenu
                defaultValue={selections?.[selectionKey]?.find((option) => option?.value?.toLowerCase() === values?.[name]?.toLowerCase())}
                errors={errors}
                getRenderedOption={(option) => option?.label}
                label={label}
                name={name}
                optionLabel={(option) => option?.label}
                options={name === fileNameInputName && !getValues(fileTypeInputName) ? [] : selections?.[selectionKey]}
                onChange={(_, option) => changeAutoCompleteMenuValueHandler(
                    option,
                    name,
                    field,
                )}

            />
        );
    };

    if (fileType === fileData.types.track || !fileType) {
        return (
            <FoldersStructureTrackFileForm
                action={action}
                modalData={modalData}
                setModalData={setModalData}
                values={{
                    fileType: !fileType ? "" : fileData.types.track,
                    id: values.id,
                }}
                onSubmitForm={onSubmitForm}
            />
        );
    }

    if (fileType === fileData.types.artwork) {
        return (
            <FoldersStructureArtworkFileForm
                action={action}
                modalData={modalData}
                setModalData={setModalData}
                values={{
                    fileType: fileData.types.artwork,
                    id: values.id,
                }}
                onSubmitForm={onSubmitForm}
            />
        );
    }

    return (
        <FormContainer
            action={action}
            formMethods={formMethods}
            setModalData={setModalData}
            data={renderFormControllerHandler(
                control,
                foldersStructureXmlFileFormData,
                renderFormControllerChildrenHandler,
            )}
            hasCancelButton
            withoutShadow
            onSubmitForm={onSubmitForm}
        />
    );
};

export default FoldersStructureXmlFileForm;

FoldersStructureXmlFileForm.propTypes = {
    action: PropTypes.string,
    modalData: PropTypes.object,
    onSubmitForm: PropTypes.func,
    setModalData: PropTypes.func,
    values: PropTypes.object,
};
